import { Stack } from '@mui/material';
import { isNotNullOrUndefined } from '@vy/utils';
import React from 'react';
import { Helmet } from 'react-helmet';
import { useQueryClient } from 'react-query';
import { PdfViewer } from '../../../components/new-design/layout/PdfViewer/PdfViewer';
import { withSuspenseBoundary } from '../../../components/utility/SuspenseBoundary';
import { prefetchInvoicePdf, useInvoicePdf } from '../../../hooks/requests/use-invoice-pdf';
import { useValidatedParams } from '../../../hooks/use-validated-params';
import { useInvoice } from '../../../hooks/requests/use-invoice';
import { DynamicInvoiceViewPageInvoiceNotFound } from '../DynamicInvoiceViewPage/dynamic-invoice-view-components/DynamicInvoiceViewPageInvoiceNotFound';

const LightInvoiceViewPage: React.FC = () => {
  const { invoiceId } = useValidatedParams<['invoiceId']>('invoiceId');
  const queryClient = useQueryClient();

  // Overlap the PDF with the invoice fetch; sibling suspense queries serialize in react-query v3 otherwise.
  void prefetchInvoicePdf(invoiceId, queryClient);

  const { data } = useInvoice(invoiceId, { suspense: true });
  const { data: invoicePdf } = useInvoicePdf(invoiceId, { suspense: true });
  const { invoice } = data;

  return (
    <>
      <Helmet>
        <title>{`Invoice ${invoice?.name ?? ''}`}</title>
      </Helmet>
      <>
        <Stack
          spacing={4}
          sx={{
            width: '100%',
            padding: '32px',
            overflowY: 'auto',
            alignItems: 'center',
          }}
        >
          {isNotNullOrUndefined(invoicePdf) && <PdfViewer base64EncodedPdf={invoicePdf.encodedPdf} />}
        </Stack>
      </>
    </>
  );
};

const LightInvoiceViewPageWithSuspenseBoundary = withSuspenseBoundary(LightInvoiceViewPage, {
  errorBoundaryProps: {
    fallback: (
      <div style={{ width: '100%', height: '100%' }}>
        <DynamicInvoiceViewPageInvoiceNotFound />
      </div>
    ),
  },
});

export { LightInvoiceViewPageWithSuspenseBoundary as LightInvoiceViewPage };
